import React, { Component } from "react";
import Table from "./../common/table";
import FormatDate from "./../common/formatDate";
import { Link } from "react-router-dom";
import moment from "moment"
import { CopyToClipboard } from "react-copy-to-clipboard";
import Barcode from "react-barcode";

class RVSsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      copiedCode: null, // Track which code was recently copied
    };
  }

  handleCopySuccess = (codeNr) => {
    this.setState({ copiedCode: codeNr });
    // Reset the copied state after 2 seconds
    setTimeout(() => {
      this.setState({ copiedCode: null });
    }, 2000);
  };

  // Helper function to get badge color based on CoO value
  getCOOBadgeClass = (value) => {
    const lowerValue = value?.toString().toLowerCase().trim();
    if (lowerValue === 'yes') {
      return 'badge bg-danger mb-1'; // Red for Yes
    } else if (lowerValue === 'no') {
      return 'badge bg-success mb-1'; // Green for No
    } else {
      return 'badge bg-primary mb-1'; // Default blue for other values
    }
  };

  // Helper function to get badge color based on Batch value
  getBatchBadgeClass = (value) => {
    const upperValue = value?.toString().toUpperCase().trim();
    if (upperValue === 'NBY') {
      return 'badge bg-warning mb-1'; // Warning (yellow) for NBY
    } else if (upperValue === 'FOU') {
      return 'badge bg-info mb-1'; // Info (light blue) for FOU
    } else {
      return 'badge bg-primary mb-1'; // Default blue for other values
    }
  };

  columns = [
    //   {path: '_id', label: 'Id'},
    {
      key: "checkbox",
      width: "30px",
      className: "checkbox-column",
      style: { 
        padding: "5px", 
        margin: "0",
        textAlign: "center",
        maxWidth: "30px",
        minWidth: "30px",
        width: "30px"
      },
      label: (
        <input
          type="checkbox"
          style={{
            width: "15px",
            height: "15px",
            margin: "0",
            borderRadius: 0,
          }}
          onChange={this.props.handleSelectAllChange}
        />
      ),
      content: (RVS) => (
        <input
          type="checkbox"
          style={{
            width: "15px",
            height: "15px",
            margin: "0",
            borderRadius: 0,
          }}
          onChange={this.props.handleCheckboxChange}
          value={RVS._id}
          checked={this.props.checkedFields.includes(RVS._id)}
        />
      ),
    },
    { 
      label: "Code", 
      content: (RVS) => (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'flex-start',
          gap: '8px',
          minWidth: 'auto',
          padding: '8px 4px 8px 8px',
          margin: '0px',
          width: 'fit-content'
        }}>
          {/* Barcode Display */}
          <div style={{ 
            background: 'transparent', 
            padding: '4px 8px', 
            borderRadius: '4px',
            border: '1px solid #e0e0e0',
            margin: '0px',
            display: 'inline-block'
          }}>
            <Barcode 
              value={RVS.codeNr || "N/A"} 
              width={1.2}
              height={40}
              fontSize={10}
              background="#ffffff"
              lineColor="#000000"
              displayValue={true}
              margin={0}
            />
          </div>
          
          {/* Copy to Clipboard Icon */}
          <CopyToClipboard 
            text={RVS.codeNr || ""}
            onCopy={() => {
              this.handleCopySuccess(RVS.codeNr);
              console.log('Code copied to clipboard:', RVS.codeNr);
            }}
          >
            <button 
              className="copy-button"
              style={{
                background: this.state.copiedCode === RVS.codeNr ? '#d4edda' : 'none',
                border: `1px solid ${this.state.copiedCode === RVS.codeNr ? '#28a745' : '#ddd'}`,
                cursor: 'pointer',
                padding: '2px 4px',
                borderRadius: '3px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: this.state.copiedCode === RVS.codeNr ? '#28a745' : '#007bff',
                fontSize: '12px',
                minWidth: '20px',
                height: '20px'
              }}
              title={this.state.copiedCode === RVS.codeNr ? 'Copied!' : `Copy code: ${RVS.codeNr}`}
            >
              <i className={this.state.copiedCode === RVS.codeNr ? "fas fa-check" : "fas fa-copy"}></i>
            </button>
          </CopyToClipboard>
        </div>
      )
    },	
    { 
      label: "Name", 
      content: (RVS) => {
        return <span>{RVS.RVS}</span>;
      }
    },	
    { 
      label: "Batch", 
      content: (RVS) => (
        <span>
          {RVS.itemBatch && typeof RVS.itemBatch === 'string' ? 
            RVS.itemBatch.split(', ').map((way, index, array) => (
              <span 
                key={index} 
                className={this.getBatchBadgeClass(way)}
                style={{ 
                  marginRight: index < array.length - 1 ? '4px' : '0'
                }}
              >
                {way}
              </span>
            )) : 
            (Array.isArray(RVS.itemBatch) 
              ? RVS.itemBatch.map((way, index, array) => (
                  <span 
                    key={index} 
                    className={this.getBatchBadgeClass(way)}
                    style={{ 
                      marginRight: index < array.length - 1 ? '4px' : '0'
                    }}
                  >
                    {way}
                  </span>
                ))
              : RVS.itemBatch || ""
            )
          }
        </span>
      )
    },
    { 
      label: "Country", 
      content: (RVS) => {
        return <span>{RVS.country}</span>;
      }
    },	
    { 
      label: "Tags", 
      content: (RVS) => {
        return <span>{RVS.tags}</span>;
      }
    },	

    { 
      label: "ReceivingWay", 
      content: (RVS) => {
        const clickableIds = ["ZZETES00-1-1-2", "ZZETES00-1-1-6", "ZZETES00-1-1-3"];
        
        const renderBadge = (way, index, array) => {
          const isClickable = clickableIds.includes(way);
          const badgeStyle = { 
            marginRight: index < array.length - 1 ? '4px' : '0',
            textDecoration: 'none',
            cursor: isClickable ? 'pointer' : 'default'
          };
          
          if (isClickable) {
            return (
              <a 
                key={index}
                href={`${window.location.origin}/workinstructions/ALUInbound#${way}`}
                className="badge bg-primary mb-1" 
                style={badgeStyle}
                onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                onMouseLeave={(e) => e.target.style.opacity = '1'}
              >
                {way}
              </a>
            );
          } else {
            return (
              <span 
                key={index} 
                className="badge bg-primary mb-1" 
                style={badgeStyle}
              >
                {way}
              </span>
            );
          }
        };
        
        return (
          <span>
            {RVS.receivingWay && typeof RVS.receivingWay === 'string' ? 
              RVS.receivingWay.split(', ').map(renderBadge) : 
              (Array.isArray(RVS.receivingWay) 
                ? RVS.receivingWay.map(renderBadge)
                : RVS.receivingWay || ""
              )
            }
          </span>
        );
      }
    },
    { 
      label: "CoO Checking", 
      content: (RVS) => (
        <span>
          {RVS.COO && typeof RVS.COO === 'string' ? 
            RVS.COO.split(', ').map((way, index, array) => (
              <span 
                key={index} 
                className={this.getCOOBadgeClass(way)}
                style={{ 
                  marginRight: index < array.length - 1 ? '4px' : '0'
                }}
              >
                {way}
              </span>
            )) : 
            (Array.isArray(RVS.COO) 
              ? RVS.COO.map((way, index, array) => (
                  <span 
                    key={index} 
                    className={this.getCOOBadgeClass(way)}
                    style={{ 
                      marginRight: index < array.length - 1 ? '4px' : '0'
                    }}
                  >
                    {way}
                  </span>
                ))
              : RVS.COO || ""
            )
          }
        </span>
      )
    },

  ];

  render() {
    const { rvss, onSort, sortColumn } = this.props;

    return (
      <div>
        <style>
          {`
            .table .checkbox-column,
            .table th.checkbox-column,
            .table td.checkbox-column,
            .table-responsive .table .checkbox-column,
            .table-responsive .table th.checkbox-column,
            .table-responsive .table td.checkbox-column {
              width: 30px !important;
              max-width: 30px !important;
              min-width: 30px !important;
              text-align: center !important;
              vertical-align: middle !important;
              padding: 5px !important;
              margin: 0 !important;
              border-right: none !important;
            }
            .table .checkbox-column input[type="checkbox"],
            .table th.checkbox-column input[type="checkbox"],
            .table td.checkbox-column input[type="checkbox"] {
              margin: 0 auto !important;
              padding: 0 !important;
              vertical-align: middle !important;
              display: block !important;
              width: 15px !important;
              height: 15px !important;
            }
            .table th:first-child,
            .table td:first-child {
              width: 30px !important;
              max-width: 30px !important;
              min-width: 30px !important;
              padding: 5px !important;
              text-align: center !important;
              vertical-align: middle !important;
            }
            
            /* Barcode column styling */
            .table td:nth-child(2) {
              min-width: auto !important;
              text-align: left !important;
              vertical-align: middle !important;
              padding: 8px !important;
              white-space: nowrap !important;
              width: 300px !important;
              max-width: 300px !important;
            }
            
            /* Barcode styling - Force remove all margins */
            .table td:nth-child(2) canvas {
              max-width: 100% !important;
              height: auto !important;
              margin: 0 !important;
              padding: 0 !important;
              display: block !important;
            }
            
            /* Force remove margins from barcode SVG/Canvas */
            .table td:nth-child(2) svg,
            .table td:nth-child(2) canvas {
              margin-left: 0 !important;
              margin-right: 0 !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
              padding-left: 0 !important;
              padding-right: 0 !important;
              border: none !important;
            }
            
            /* Copy button hover effects */
            .copy-button {
              transition: all 0.2s ease-in-out;
            }
            
            .copy-button:hover {
              transform: scale(1.05);
              background-color: #f8f9fa !important;
              border-color: #007bff !important;
            }
            
            /* Table row height optimization */
            .table td {
              vertical-align: middle !important;
            }
            
            /* CoO Checking and Batch badge color enhancements */
            .badge.bg-danger {
              background-color: #dc3545 !important; /* Red for Yes */
              color: white !important;
            }
            
            .badge.bg-success {
              background-color: #28a745 !important; /* Green for No */
              color: white !important;
            }
            
            .badge.bg-warning {
              background-color: #ffc107 !important; /* Warning yellow for NBY */
              color: #212529 !important; /* Dark text for better contrast */
            }
            
            .badge.bg-info {
              background-color: #17a2b8 !important; /* Info light blue for FOU */
              color: white !important;
            }
            
            .badge.bg-primary {
              background-color: #007bff !important; /* Blue for other values */
              color: white !important;
            }
          `}
        </style>
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={rvss}
        />
      </div>
    );
  }
}

export default RVSsTable;
